import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { getApi } from "../../api/api";

import { ClusterInterface } from "../../common/types/interfaces";
import { useCityId } from "../../common/hooks/useCityId";

export const useCluster = () => {
  const [searchParams] = useSearchParams();
  const search = searchParams.get("search") || "";

  const cityId = useCityId();

  const [clusters, setClusters] = useState<ClusterInterface[]>([]);
  const [loading, setLoading] = useState(true);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setIsFetching(true);

    getApi()
      .getClusters({
        target: "logmall",
        search: search || undefined,
        cityId,
      })
      .then((data) => {
        if (!cancelled) {
          setClusters(data);
          setLoading(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setClusters([]);
          setLoading(false);
        }
      })
      .finally(() => {
        if (!cancelled) setIsFetching(false);
      });

    return () => {
      cancelled = true;
    };
  }, [search, cityId]);

  return {
    items: clusters,
    count: clusters.length,
    ready: !loading,
    isFetching,
  };
};
